import Colors from "../../../global/Colors";

export const FilterListConfig = [
  {
    fieldName: "search",
    title: "Search",
    filterType: "Search",
    currentValue: "",
    activeChip: {
      isActive: false,
      color: Colors.green[500],
      label: "",
      clearValueOnDelete: true,
    },
  },
  {
    fieldName: "provider",
    title: "Provider",
    filterType: "MultiSelectSearch",
    searchTitle: "Search Providers",
    currentValue: [],
    nameKey: "label",
    valueKey: "key",
    apiUrl: `core/dynamic-options/providers/`,
    permission: "",
    activeChip: {
      isActive: false,
      color: Colors.sky[500],
      label: "",
    },
  },
  {
    fieldName: "client",
    title: "Client",
    filterType: "MultiSelectSearch",
    searchTitle: "Search Clients",
    currentValue: [],
    nameKey: "label",
    valueKey: "key",
    apiUrl: `core/dynamic-options/clients/`,
    permission: "",
    activeChip: {
      isActive: false,
      color: Colors.purple[500],
      label: "",
    },
  },
  {
    fieldName: "provider_type",
    title: "Provider Type",
    filterType: "MultiSelectSearch",
    searchTitle: "Search Provider Types",
    currentValue: null,
    nameKey: "value",
    valueKey: "key",
    apiUrl: `core/dynamic-options/provider-type/`,
    permission: "",
    activeChip: {
      isActive: false,
      color: Colors.blue[500],
      label: "",
    },
  },
  {
    fieldName: "case__overall_status",
    title: "Case Status",
    filterType: "MultiSelectSearch",
    searchTitle: "Search Case Status",
    currentValue: [],
    orderingVal: "order",
    nameKey: "label",
    valueKey: "key",
    apiUrl: `field_options/?content_type=case&field_name=overall_status&flat=true`,
    permission: "",
    activeChip: {
      isActive: false,
      color: Colors.green[500],
      label: "",
    },
  },
  {
    fieldName: "case__status",
    title: "Medical Status",
    filterType: "MultiSelectSearch",
    searchTitle: "Search Medical Status",
    currentValue: [],
    orderingVal: "order",
    nameKey: "label",
    valueKey: "key",
    apiUrl: `field_options/?content_type=case&field_name=status&flat=true`,
    permission: "",
    activeChip: {
      isActive: false,
      color: Colors.gray[400],
      label: "",
    },
  },
  {
    fieldName: "case__legal_status",
    title: "Legal Status",
    filterType: "MultiSelectSearch",
    searchTitle: "Search Legal Status",
    currentValue: [],
    orderingVal: "order",
    nameKey: "label",
    valueKey: "key",
    apiUrl: `field_options/?content_type=case&field_name=legal_status&flat=true`,
    permission: "",
    activeChip: {
      isActive: false,
      color: Colors.green[400],
      label: "",
    },
  },
  {
    fieldName: "provider__in_network",
    title: "In Network",
    filterType: "SearchOptionGroup",
    currentValue: null,
    customFalseLabel: null,
    customTrueLabel: null,
    permission: "",
    activeChip: {
      isActive: false,
      color: Colors.teal[500],
      label: "",
    },
  },
  {
    fieldName: "finished_treatment",
    title: "Treatment Complete",
    filterType: "SearchOptionGroup",
    currentValue: null,
    customFalseLabel: null,
    customTrueLabel: null,
    permission: "",
    activeChip: {
      isActive: false,
      color: Colors.gray[500],
      label: "",
    },
  },
  {
    fieldName: "created_at",
    title: "Created At",
    filterType: "DateRange",
    currentValue: {
      __gte: undefined,
      __lte: undefined,
    },
    permission: "",
    activeChip: {
      isActive: false,
      color: Colors.gray[400],
      label: "",
    },
  },
];
